import { Tabs, TabsProps } from 'antd';
import { ListedPropertyDetailMemberAuctionProperty } from 'domain/entities/PropertyEntity';
import { AppProps } from 'presentation/App';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { setVisibleCU01702 } from 'presentation/redux/features/CU/CU01702Slice';
import {
    completeFetching,
    showAlert,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { TodoEntity } from '../CU-002-02/models/CardModel';
import TAB2Component from '../CU-002-03/tab2';
import TAB3Component from '../CU-002-03/tab3';
import TAB1Component from './tab1';

const CU01702Page = (prop: AppProps) => {
    const location = useLocation();
    const { listedPropertyId } = useParams();
    const [searchParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { currentTodo, memberTodo } = location.state ?? { currentTodo: '', memberTodo: '' };
    const [detailAssessment, setDetailAssessment] =
        useState<ListedPropertyDetailMemberAuctionProperty>();
    useEffect(() => {
        (async () => {
            await getListedPropertyRoomGetAssessmentDetail({
                listedPropertyId: Number(listedPropertyId),
            });
        })();
    }, []);
    const getListedPropertyRoomGetAssessmentDetail = async (params: {
        listedPropertyId: number;
    }) => {
        try {
            dispatch(startFetching());
            const response = await prop.propertyUseCase.getDetailAuctionOfMember(params);
            if (response) {
                // if (response.result.isLogin) {
                    setDetailAssessment(response.result);
                // } else {
                //     navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`);
                // }
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const checkCancelSellingPrice = async () => {
        try {
            dispatch(startFetching());
            const response = await prop.propertyUseCase.checkCancelListedProperty({
                auctionId: Number(detailAssessment?.auctionId),
            });
            if (response.status == '200') {
                cancelSellingPrice();
            }
        } catch (error: any) {
            if (error && error.message) {
                const alertProps = {
                    message: error.message,
                    type: 'warning',
                    title: '確認',
                    okText: 'OK',
                    onOk: () => backToDashBoard(),
                };
                dispatch(showAlert(alertProps));
            }
        } finally {
            dispatch(completeFetching());
        }
    };

    const cancelSellingPrice = () => {
        dispatch(setVisibleCU01702());
    };

    const checkChangeSellingPrice = async () => {
        try {
            dispatch(startFetching());
            const response = await prop.propertyUseCase.checkChangeSellingPrice({
                auctionId: Number(detailAssessment?.auctionId),
            });
            if (response.status == '200') {
                changeSellingPrice();
            }
        } catch (error: any) {
            if (error && error.message) {
                const alertProps = {
                    message: error.message,
                    type: 'warning',
                    okText: 'OK',
                    onOk: () => backToDashBoard(),
                };
                dispatch(showAlert(alertProps));
            }
        } finally {
            dispatch(completeFetching());
        }
    };

    const backToDashBoard = () => {
        navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.DASHBOARD + '?tab=2');
    };

    const changeSellingPrice = () => {
        navigate(
            `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_036_01}/${detailAssessment?.propertyId}/${listedPropertyId}/${detailAssessment?.auctionId}`,
        );
    };

    const TabInfomation: TabsProps['items'] = [
        {
            label: '物件情報',
            key: '1',
            children: (
                <TAB1Component
                    masterUseCase={prop.masterUseCase}
                    propertyUseCase={prop.propertyUseCase}
                    detailAssessment={detailAssessment}
                />
            ),
        },
        {
            label: 'TODOリスト',
            key: '2',
            children: <TAB2Component memberTodo={memberTodo as TodoEntity[]} />,
        },
        {
            label: 'ステータス',
            key: '3',
            children: (
                <TAB3Component
                    type={searchParams.get('type') || String(BUYER_CLASSIFICATION)}
                    level1={'0-' + searchParams.get('tabIndex') || ''}
                    level2={currentTodo?.todoClassId || ''}
                />
            ),
        },
        {
            label: '申込書/契約書',
            key: '4',
            children: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ fontWeight: 700, fontSize: 16, marginTop: 300, height: '90%' }}>
                        申込書・契約書はありません
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                textAlign: 'center',
            }}
            className="CU-017-02-container "
        >
            <PageTitle title="取引詳細" />
            <Tabs
                defaultActiveKey="1"
                className="tab-dashboard-title-container"
                items={TabInfomation}
            />
            <section>
                <div style={{ display: 'flex', width: '100%' }}>
                    <div
                        style={{
                            display: 'flex',
                            width: '50%',
                            alignContent: 'end',
                            justifyContent: 'end',
                        }}
                    >
                        <div
                            className="form-button login-form-button"
                            style={{
                                cursor: 'pointer',
                                background: '#1F8DDD',
                            }}
                            onClick={checkChangeSellingPrice}
                        >
                            価格変更申請
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            width: '50%',
                            alignContent: 'end',
                            paddingLeft: '10px',
                        }}
                    >
                        <div
                            className="form-button simulate-form-button"
                            style={{ background: '#B52A21' }}
                            onClick={checkCancelSellingPrice}
                        >
                            出品取り下げ申請
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CU01702Page;
